// src/components/CookieBanner.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // On vérifie si l'utilisateur a déjà accepté (stocké dans le navigateur)
        const hasConsented = localStorage.getItem('insulated_cookie_consent');
        if (!hasConsented) {
            // Petit délai pour ne pas gêner le chargement initial de la page
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('insulated_cookie_consent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-banner-wrapper">
            <div className="cookie-banner-content">
                <div className="cookie-banner-icon">🍪</div>
                <div className="cookie-banner-text">
                    <h4 className="cookie-banner-title">Respect de votre vie privée</h4>
                    <p className="cookie-banner-description">
                        INSULATED utilise uniquement des <strong>cookies strictement nécessaires</strong> au bon fonctionnement de votre compte (authentification, sécurité et préférences de devise). 
                        Aucun cookie publicitaire ni traceur tiers n'est utilisé.
                    </p>
                </div>
                <div className="cookie-banner-actions">
                    <Link to="/profile" className="cookie-btn-link">
                        En savoir plus
                    </Link>
                    <button onClick={handleAccept} className="cookie-btn-accept">
                        J'ai compris
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;